import { ActionType } from "../constants/ActionTypes";
import config from "../constants/Configs";
import { LocalStorageService } from "../services/LocalStorageService";
import { SessionStorageService } from "../services/SessionStorageService";
import { Constants } from "../constants/Constants";
import { RestPath } from "../constants/SitePaths";
import PopupEnum from "../components/base/PopupEnum";
import { TFAVerificationEnum } from "../components/base/tfa/TFAVerificationEnum";
import { CustomErrors } from "../constants/Errors/CustomErrors";
import axios from "axios";
import store from "../index";
import NotificationService from "../components/base/notifications/NotificationService";
import { Browser } from "../services/helpers/Browser";
import { TriggerHelper, TriggerEvents } from "../components/base/businessRules/TriggerHelper";
import Utils from "../services/Utils";
import { checkRussianVerificationStatuses, checkRussianVerificationStatusesV2 } from "./account/AccountAction";
import { CupisClientStatusEnum } from "../components/myProfile/CupisStatusesEnum";
import ProfileEnum from "../components/myProfile/payments/enums/ProfileEnum";
import { changeMyProfilePopupVisibility } from "./ControlsAction";
import { getRealityCheck } from "./account/ResponsibleGamingActions";
import { RealityCheckPeriodEnum } from "../components/myProfile/responsibleGaming/realityCheck/RealityCheckPeriodEnum";
import UniqueUserIdService from "../services/uniqueUserId/UniqueUserIdService";
import { RealityCheckStatusEnum } from "../components/myProfile/responsibleGaming/realityCheck/RealityCheckEnum";
import { setCurrency } from "./settings/SettingsAction";
import { IdentificationFlowEnum } from "../components/myProfile/profileInfo/Identification/IdentificationEnum";
import { Auth } from '../services/Auth'
import { ErrorHelper } from "../services/helpers/error/ErrorHelper";
import { LanguageService } from "../services/LanguageService";
import { SiteLayoutHelper } from "../services/helpers/SiteLayoutHelper";
import Base64Helper from "../services/helpers/Base64Helper";

let refreshTokenRequestSent = false;
let subscribers = [];

// User Logout
export const logout = () => {
  TriggerHelper.triggerEvent(TriggerEvents.logout)
  return ({
    type: ActionType.USER_LOGOUT,
  })
};

// User Login
export const loginUserBegin = () => ({
  type: ActionType.LOGIN_USER_BEGIN,
});

export const changePopupVisibility = (data) => ({
  type: ActionType.CHANGE_POPUP_VISIBILITY,
  payload: data,
});

export const loginUserSuccess = (user) => ({
  type: ActionType.LOGIN_USER_SUCCESS,
  payload: { user },
});

export const dispatchAlert = (data) => ({
  type: ActionType.DISPATCH_ALERT,
  payload: data,
});


export const getSessionHistoryBegin = () => ({
  type: ActionType.LOGIN_USER_BEGIN,
});

export const getSessionHistorySuccess = (data) => ({
  type: ActionType.CHANGE_POPUP_VISIBILITY,
  payload: data,
});

export const getSessionHistoryError = (user) => ({
  type: ActionType.LOGIN_USER_SUCCESS,
  payload: { user },
});

export const quitSessionsBegin = () => ({
  type: ActionType.QUIT_SESSIONS_BEGIN,
});

export const quitSessionsSuccess = (data) => ({
  type: ActionType.QUIT_SESSIONS_SUCCESS,
  payload: data,
});

export const quitSessionsError = (user) => ({
  type: ActionType.QUIT_SESSIONS_Error,
  payload: { user },
});

export const loginUserError = (user, error) => ({
  type: ActionType.LOGIN_USER_FAILURE,
  payload: { error: error, user: user },
});

export const getLocationSuccess = (data) => ({
  type: ActionType.GET_LOCATION_SUCCESS,
  payload: data,
});

// User Forgot Password
export const forgotPasswordRecoveryBegin = () => ({
  type: ActionType.FORGOT_PASSWORD_RECOVERY_BEGIN,
});

export const forgotPasswordRecoverySuccess = (data) => ({
  type: ActionType.FORGOT_PASSWORD_RECOVERY_SUCCESS,
  payload: data,
});

export const forgotPasswordRecoveryError = (error) => ({
  type: ActionType.FORGOT_PASSWORD_RECOVERY_ERROR,
  payload: error,
});

// User Recover Password
export const recoverPasswordBegin = () => ({
  type: ActionType.RECOVER_PASSWORD_BEGIN,
});

export const recoverPasswordSuccess = (data) => ({
  type: ActionType.RECOVER_PASSWORD_SUCCESS,
  payload: data,
});

export const recoverPasswordError = (error) => ({
  type: ActionType.RECOVER_PASSWORD_ERROR,
  payload: error,
});

// Recover Username
export const recoverUserNameBegin = () => ({
  type: ActionType.RECOVER_USER_NAME_BEGIN,
});

export const recoverUserNameSuccess = (data) => ({
  type: ActionType.RECOVER_USER_NAME_SUCCESS,
  payload: data,
});

export const recoverUserNameError = (error) => ({
  type: ActionType.RECOVER_USER_NAME_ERROR,
  payload: error,
});

export const changePasswordBegin = () => ({
  type: ActionType.CHANGE_PASSWORD_BEGIN,
});

export const changePasswordSuccess = (data) => ({
  type: ActionType.CHANGE_PASSWORD_SUCCESS,
  payload: data,
});

export const changePasswordError = (error) => ({
  type: ActionType.CHANGE_PASSWORD_ERROR,
  payload: error,
});

export const playerDataReset = (data) => ({
  type: ActionType.PLAYER_DATA_RESET,
  payload: data,
});

export const getPlayerDataBegin = () => ({
  type: ActionType.GET_PLAYER_DATA_BEGIN,
});

export const getPlayerDataError = (data) => ({
  type: ActionType.GET_PLAYER_DATA_ERROR,
  payload: data,
});

export const getPlayerDataSuccess = (data) => ({
  type: ActionType.GET_PLAYER_DATA_SUCCESS,
  payload: data,
});

export const getAccountWalletsError = (data) => ({
  type: ActionType.GET_ACCOUNT_WALLETS_ERROR,
  payload: data,
});

export const getAccountWalletsSuccess = (data) => ({
  type: ActionType.GET_ACCOUNT_WALLETS_SUCCESS,
  payload: data,
});

export const getPlayerBalanceBegin = (data) => ({
  type: ActionType.GET_PLAYER_BALANCE_BEGIN,
  payload: data,
});

export const getPlayerBalanceError = (data) => ({
  type: ActionType.GET_PLAYER_BALANCE_ERROR,
  payload: data,
});

export const getPlayerBalanceSuccess = (data) => ({
  type: ActionType.GET_PLAYER_BALANCE_SUCCESS,
  payload: data,
});

export const setPlayerSportBonusBalance = (data) => ({
  type: ActionType.SET_PLAYER_SPORT_BONUS_BALANCE,
  payload: data,
});

export const setMyBetsCount = (data) => ({
  type: ActionType.SET_MY_BETS_COUNT,
  payload: data,
});

export const setPlayerSportTournamentBalance = (data) => ({
  type: ActionType.SET_PLAYER_SPORT_TOURNAMENTS_BALANCE,
  payload: data,
});

export const refreshTokenBegin = () => ({
  type: ActionType.REFRESH_TOKEN_BEGIN,
});

export const refreshTokenSuccess = () => ({
  type: ActionType.REFRESH_TOKEN_SUCCESS,
});
export const refreshTokenError = () => ({
  type: ActionType.REFRESH_TOKEN_ERROR,
});
export const setRedirectUrl = (data) => ({
  type: ActionType.SET_REDIRECT_URL,
  payload: data,
});
export const getDormantCodeSuccess = (data) => ({
  type: ActionType.GET_DORMANT_CODE_SUCCESS,
  payload: data,
});

export const getDormantCodeBegin = (data) => ({
  type: ActionType.GET_DORMANT_CODE_BEGIN,
  payload: data,
});

export const getDormantCodeError = (data) => ({
  type: ActionType.GET_DORMANT_CODE_ERROR,
  payload: data,
});

//User info Block
export const getInfoBlockBegin = (data) => ({
  type: ActionType.GET_INFO_BLOCK_BEGIN,
  payload: data,
});

export const getInfoBlockSuccess = (data) => ({
  type: ActionType.GET_INFO_BLOCK_SUCCESS,
  payload: data,
});
export const getInfoBlockError = (data) => ({
  type: ActionType.GET_INFO_BLOCK_ERROR,
  payload: data,
});
export const changeLoginState = (data) => ({
  type: ActionType.CHANGE_LOGIN_STATE,
  payload: data,
});

export const setMobileNavMenuOpenBegin = (data) => ({
  type: ActionType.TOGGLE_MOBILE_NAV_MENU,
  payload: data
})

export const setNavBurgerBtnStateBegin = (data) => ({
  type: ActionType.TOGGLE_SIDEBAR_MENU,
  payload: data
});

export function setNavBurgerBtnState(data) {
  return (dispatch) => {
    dispatch(setNavBurgerBtnStateBegin(data));
    return data;
  }
}

export function setMobileNavMenuOpen(data) {
  return (dispatch) => {
    dispatch(setMobileNavMenuOpenBegin(data));
    return data;
  }
}

export const realityCheckPopupVisibility = (data) => ({
  type: ActionType.REALITY_CHECK_POPUP_VISIBILITY,
  payload: data
});

export const showBalance = (data) => ({
  type: ActionType.SHOW_BALANCE,
  payload: data,
});
/* Get user block info */
export function getUserBlockData() {
  return (dispatch) => {
    dispatch(getInfoBlockBegin());
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_PLAYER_ADDITIONAL_INFO}`,
    })
      .then((response) => {
        dispatch(getInfoBlockSuccess(response.data));
      })
      .catch((error) => {
        if (error.response) {
          dispatch(getInfoBlockError(error.response.data));
        } else {
          dispatch(getInfoBlockError(error));
        }
      });
  };
}

/* User Login 
  * @param {Object} data   login data
  * @param {String} grant_type   grant type
  * @param {Boolean} loginAfterRegistration   is after register
*/

export function loginUser(data, grant_type = "password", loginAfterRegistration = false) {
  return (dispatch) => {
    dispatch(loginUserBegin());
    dispatch(playerDataReset());
    const deviceType = Browser.getDeviceType();

    const params = {
      ...data,
      deviceType,
      deviceName: Utils.getDeviceNameFromUserAgent(),
      grant_type: grant_type,
      client_id: config.REACT_APP_CLIENT_ID,
      uniqueId: UniqueUserIdService.getUniqueUserId()
    };

    if (!config.NEW_PLAT) {
      params.pId = store.getState().settings?.projectId;
      params.p = Base64Helper.encode(Browser.getDomain());
    }

    //Encode the data
    const body = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.LOGIN,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: body,
    }).then((response) => {
        return handleLoginResponse(response, dispatch, loginAfterRegistration);
    }).catch((error) => {
        return handleLoginError(params, error, dispatch);
      });
  };
}

/**
 *  Handle login response and set authorization data to local storage, 
 *  dispatch get player data and check russian verification statuses,
 *  show identification form if needed,
 *  trigger login event and resize event,
 *  set reality check period to local storage
 * @param {Object} response
 * @param {Function} dispatch
 * @param {Boolean} loginAfterRegistration
 */

export function handleLoginResponse(response, dispatch, loginAfterRegistration) {
  LocalStorageService.set("authorizationData", response.data);
  dispatch(getPlayerData()).then((res) => {
    store.getState().settings?.plugins?.russianServiceValidation && dispatch(checkRussianVerificationStatuses()).then((response) => {
      if (response && response.status) {
        if ((response.status === CupisClientStatusEnum.OpenDocumentsPage && response.showIdentificationForm) ||
          (response.status === CupisClientStatusEnum.ClientDetailsChecking && res?.birthDate?.indexOf('1800-01-01') >= 0)) {
          store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
            tab: ProfileEnum.Identification,
            subTab: 0
          }));
        }
      }
    });

    store.getState().settings?.plugins?.russianServiceValidation2 && dispatch(checkRussianVerificationStatusesV2()).then((response) => {
      if (response && response.ShowIdentificationForm !== IdentificationFlowEnum.EsiaAndFull && response.ShowIdentificationForm !== IdentificationFlowEnum.None && response.ShowIdentificationForm !== IdentificationFlowEnum.Full) {
        store.dispatch(changeMyProfilePopupVisibility(true, PopupEnum.MyProfile, {
          tab: ProfileEnum.Identification,
          subTab: 0
        }));
      }
    });

    !loginAfterRegistration && setTimeout(() => {
      TriggerHelper.triggerEvent(TriggerEvents.login)
    }, 10)
    setTimeout(() => {
      typeof (Event) === 'function' && window.dispatchEvent(new Event('resize'));
    }, 200)
  });

  dispatch(loginUserSuccess(response.data));

  if (Browser.isMobileApp()) {
    Utils.refreshMobilePage('login');
  }
  
  (config.NEW_PLAT ? (store.getState().settings?.features?.realityCheckStatus && store.getState().settings?.features?.realityCheckStatus !== RealityCheckStatusEnum.Disabled) : store.getState().settings?.features?.realityCheck) && dispatch(getRealityCheck()).then((response) => {
    const period = store.getState().settings?.features?.realityCheckStatus === RealityCheckStatusEnum.EnabledBrandLevel ?
      response.brandLevelPeriod : response?.current?.repetitionPeriod;

    period && LocalStorageService.set("realityCheckPeriod", RealityCheckPeriodEnum[period]);
  })
  return { status: 200, data: response.data };
}

/**
 * Handle login error and dispatch login error action
 * @param {Object} params 
 * @param {Object} error
 * @param {Function} dispatch
 * @returns {Object} error response
 */

export function handleLoginError(params, error, dispatch) {
  if (error.response) {
    dispatch(loginUserError(params, error.response.data));
    let code = error.response.data && error.response.data.code;
    !CustomErrors[code] && NotificationService.error({ message: ErrorHelper.getMessage(error), code });
  } else {
    dispatch(loginUserError(params, error));
  }
  return { status: 400, data: error.response && error.response.data };
}

export function getLoginPlayerInfo(params) {
  return (dispatch) => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_LOGIN_INFO,
      params
    })
      .then((response) => {
        const dateObj = new Date(response.data?.createdDate);

        // Pad single digits with leading zero for day, month, hours, and minutes
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
        const year = dateObj.getFullYear();
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');

        // Format as DD/MM/YYYY, HH:MM
        const formattedDate = `${day}/${month}/${year}, ${hours}:${minutes}`;
        const isNavBarVisible = SiteLayoutHelper.isNavBarVisible();
        // const isNavbarPresent = store.getState().ui?.controls?.mobileNavBar?.nestedControls?.length > 0 && isNavBarVisible;
        //Temporary solution for device type BLD-23732
        const DeviceTypeEnum = { 'Other': 1, 'Web Desktop': 4, 'Web Mobile': 8, 'Android': 64, 'Ios': 128, 'PwaApp': 2048 }
        const SessionEndReasonEnum = { 'sessionReasonLogout': 1, 'sessionReasonNewSession': 2, 'sessionReasonTimeout': 3, 'sessionReasonBlocked': 4, 'sessionReasonClosed': 5, 'sessionReasonForceLogout': 6 }
        const sessionEndReasonKey = Utils.getKeyByValue(SessionEndReasonEnum, response.data?.sessionEndReason);
        const sessionEndReason = sessionEndReasonKey ? LanguageService.getTranslation(sessionEndReasonKey, 'account') : ' - ';
        dispatch(dispatchAlert({
          placement: Utils.isMobile() ? `bottom-center` : `bottom-right`,
          size: `medium`,
          isVisible: true,
          className: `tb--alert-session`,
          icon: true,
          title: <>
            <div className="tb--alert-title"><span>{LanguageService.getTranslation('lastSessionTitle')}</span>  <span className="tb--alert-date">{formattedDate}  </span></div>
            <div className="tb--alert-content tb--mt-8">
              <span className="tb--alert-item"><span>{`IP:`}</span><span>{` ${response.data?.ip} `}</span></span>
              <span className="tb--alert-item tb--pl-10"><span>{` ${LanguageService.getTranslation('deviceType', 'account')} : `}</span><span>{`${Utils.getKeyByValue(DeviceTypeEnum, response.data?.deviceType)}`}</span></span>
            </div>
            <div className="tb--alert-content tb--mt-4">
              <span className="tb--alert-item tb--f-14"><span>{`${LanguageService.getTranslation('lastLoginSessionEndReason', 'account')}: `}</span><span> {sessionEndReason} </span></span>
            </div>
          </>
        }));

        setTimeout(() => dispatch(dispatchAlert({
          isVisible: false
        })), 5000) 

        return response.data;
      })
  }
}

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.forEach((callback) => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

export function refreshToken(authData, request, Auth) {
  const deviceType = Browser.getDeviceType();
  const params = {
    refresh_token: authData.refreshToken,
    deviceType,
    uniqueId: UniqueUserIdService.getUniqueUserId(),
    deviceName: Utils.getDeviceNameFromUserAgent(),
    grant_type: "refresh_token",
    client_id: config.REACT_APP_CLIENT_ID
  };

  //Encode the data
  const body = Object.keys(params)
    .map((key) => {
      return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");

  if (!refreshTokenRequestSent) {
    refreshTokenRequestSent = true;
    axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.LOGIN,
      data: body,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {

        if (response.status < 400) {
          LocalStorageService.set("authorizationData", response.data);
        }
        refreshTokenRequestSent = false;
        onAccessTokenFetched(response.data.access_token);
        subscribers = [];
        store.dispatch(refreshTokenSuccess());
      })
      .catch((error) => {
        // endSession(true);
        Auth.invalidateSession();
      });
  }

  const retryOriginalRequest = new Promise((resolve) => {
    addSubscriber((access_token) => {
      request.headers.Authorization = "Bearer " + access_token;
      resolve(axios(request));
    });
  });

  return retryOriginalRequest;
}


export function endSession(bLogoutRefresh, addLogoutAction) {
  const token = Auth.getAccessToken();
  if (store.getState().settings?.multiSignInEnabled || config.NEW_PLAT) {
    axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.END_SESSION,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': `Bearer ${token}`
      },
    }).then((response) => {
      bLogoutRefresh && Utils.onLogoutRefresh(addLogoutAction);
    }).catch((error) => {
      bLogoutRefresh && Utils.onLogoutRefresh(addLogoutAction);
    });

  } else {
    bLogoutRefresh && Utils.onLogoutRefresh(addLogoutAction);
  }
}

export function getLocation() {
  return (dispatch) => {
    // dispatch(getLocationBegin());
    return axios({
      url: config.BASE_URL + RestPath.GET_LOCATION,
      method: Constants.GET,
    })
      .then((response) => dispatch(getLocationSuccess(response.data)))
      .catch((error) => {
        // dispatch(getLocationError(error.response && error.response.data));
      });
  };
}

export function getClientToken() {
  return (dispatch) => {
    return axios({
      url: config.BASE_URL + RestPath.GET_TOKEN,
      method: Constants.GET,
    })
      .then((response) => response.data)
      .catch((error) => {
      });
  };
}

/* Forgot Password */
export function forgotPasswordRecovery(forgotPasswordData, history) {
  return (dispatch) => {
    dispatch(forgotPasswordRecoveryBegin());

    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.FORGOT_PASSWORD,
      headers: {
        "Content-Type": config.REACT_APP_HEADER_CONTENT_TYPE,
      },
      data: JSON.stringify(forgotPasswordData),
    })
      .then((response) => {
        dispatch(forgotPasswordRecoverySuccess(forgotPasswordData));
        dispatch(changePopupVisibility(PopupEnum.RecoverPassword));
      })
      .catch((error) => {
        if (error.response) {
          dispatch(forgotPasswordRecoveryError(error.response.data));
          NotificationService.error({ message: ErrorHelper.getMessage(error) });
        } else {
          dispatch(forgotPasswordRecoveryError(error));
        }
        return error.response && error.response.data;
      });
  };
}

/* Recover Password */
export function recoverPassword(data, history) {
  return (dispatch) => {
    dispatch(recoverPasswordBegin());
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.RECOVER_PASSWORD,
      headers: {
        "Content-Type": config.REACT_APP_HEADER_CONTENT_TYPE,
      },
      data: JSON.stringify(data),
    })
      .then((response) => {
        dispatch(recoverPasswordSuccess(response.data));
        dispatch(changePopupVisibility(PopupEnum.RecoverPasswordSuccess));
      })
      .catch((error) => {
        if (error.response) {
          dispatch(recoverPasswordError(error.response.data));
          NotificationService.error({ message: ErrorHelper.getMessage(error) });
        } else {
          dispatch(recoverPasswordError(error));
        }
        return { status: 400, data: error.response && error.response.data };
      });
  };
}
/* Recover Username */
export function recoverUserName(data) {
  return (dispatch) => {
    dispatch(recoverUserNameBegin());
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.FORGOT_USERNAME,
      headers: {
        "Content-Type": config.REACT_APP_HEADER_CONTENT_TYPE,
      },
      data: JSON.stringify(data),
    })
      .then((response) => {
        dispatch(recoverUserNameSuccess(response.data));
        dispatch(changePopupVisibility(PopupEnum.ForgotUsernameSuccess));
      })
      .catch((error) => {
        if (error.response) {
          dispatch(recoverUserNameError(error.response.data));
          NotificationService.error({ message: ErrorHelper.getMessage(error) });
        } else {
          dispatch(recoverUserNameError(error));
        }
        return { status: 400, data: error.response && error.response.data };
      });
  };
}

function getPasswordApi(bAgentLogin) {
  if (bAgentLogin) {
    return config.BASE_URL + RestPath.CHANGE_AGENT_PASSWORD;
  } else {
    return config.BASE_URL + RestPath.CHANGE_PASSWORD;
  }
}


/* Recover Password */
export function changePassword(data, bAgentLogin) {
  return (dispatch) => {
    dispatch(changePasswordBegin());

    return axios({
      method: Constants.POST,
      url: getPasswordApi(bAgentLogin),
      headers: {
        "Content-Type": config.REACT_APP_HEADER_CONTENT_TYPE,
      },
      data: JSON.stringify(data),
    })
      .then((response) => {
        dispatch(changePasswordSuccess(response.data));
        return { status: 200, data: response.data };
      })
      .catch((error) => {
        if (error.response) {
          dispatch(changePasswordError(error.response.data));
          NotificationService.error({ message: ErrorHelper.getMessage(error) });
        } else {
          dispatch(changePasswordError(error));
        }
        return { status: 400, data: error.response && error.response.data };
      });
  };
}

/* Migration password change */
export function migrationPasswordChange(data) {
  return () => {
    return axios({
      method: Constants.POST,
      url: `${config.BASE_URL}${RestPath.MIGRATION_PASSWORD_CHANGE}`,
      data
    })
  };
}

export function getPlayerData() {

  return (dispatch) => {

    dispatch(getPlayerDataBegin());
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_PLAYER_DATA,
    })
      .then((response) => {
        const playerCurrency = (store.getState().settings?.isCurrencySymbolEnabled && response.data.currencySymbol) ? response.data.currencySymbol : response.data.currencyId;

        dispatch(getPlayerDataSuccess(response.data));
        dispatch(setCurrency(playerCurrency));
        SessionStorageService.set('player', {
          userName: response.data.userName,
          email: response.data.email,
          isDocumentVerified: response.data.isDocumentVerified,
          isPhysicalVerified: response.data.isPhysicalVerified,
          id: response.data.id,
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          phoneNumber: response.data.mobileNumber
        })
        return response.data;
      })
      .catch((error) => {
        if (error.response) {
          dispatch(getPlayerDataError(error.response.data));
        } else {
          dispatch(getPlayerDataError(error));
        }
      });
  };
}

export function getAccountWallets() {
  let params = {};
  if (store.getState().settings?.features?.totalNetBalance) {
    params.includeTotalNetBalance = true;
  }
  return (dispatch) => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + (store.getState().settings.isBonusVersion2Enabled ? RestPath.GET_PLAYER_WALLETS : RestPath.GET_ACCOUNT_WALLETS),
      params: params,
    })
      .then((response) => {
        // dispatch(getAccountWalletsSuccess(response.data));
        dispatch(getAccountWalletsSuccess({
          data: response.data,
          isNewBonuses: store.getState().settings.isBonusVersion2Enabled
        }));
        SessionStorageService.set('balance', response.data?.availableBalance)
        return response.data;
      })
      .catch((error) => {
        if (error.response) {
          dispatch(getAccountWalletsError(error.response.data));
        } else {
          dispatch(getAccountWalletsError(error));
        }
      });
  };
}

export function getPlayerBalance() {
  return (dispatch) => {
    dispatch(getPlayerBalanceBegin());
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + (store.getState().settings.isBonusVersion2Enabled ? RestPath.GET_ACCOUNT_BALANCE : RestPath.GET_PLAYER_BALANCE),
    })
      .then((response) => {
        dispatch(getPlayerBalanceSuccess({ data: response.data, isNewBonuses: store.getState().settings.isBonusVersion2Enabled }));
        SessionStorageService.set('balance', response.data)
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            dispatch(getPlayerBalanceError(error.response.data));
            return error.response.status;
          }
        } else {
          dispatch(getPlayerBalanceError(error));
        }
      });
  };
}

export function getDormantCode(data) {
  return (dispatch) => {
    const params = {
      userName: data.userName,
      emailOrMobile: data.emailOrMobile,
      type: TFAVerificationEnum.DormantActivate,
    };
    dispatch(getDormantCodeBegin());
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.SEND_2FA_CODE,
      data: params,
    })
      .then((response) => {
        dispatch(getDormantCodeSuccess(response.data));
        return { status: 200, data: response.data };
      })
      .catch((error) => {
        if (error.response) {
          dispatch(getDormantCodeError(error.response.data));
          NotificationService.error({ message: ErrorHelper.getMessage(error) });
        } else {
          dispatch(getDormantCodeError(error));
        }
      });
  };
}
export function sendCupisV2Code(clientId) {
  return (dispatch) => {
    const params = {
      clientId,
    };
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.SEND_CUPISV2_CODE,
      data: params,
    }).then((response) => {
      return { status: 200, data: response.data };
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function resendTrustedCode(params) {
  return (dispatch) => {

    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.RESEND_TRUSTED_CODE,
      data: params,
    }).then((response) => {
      return { status: 200, data: response.data };
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function enableTrustedDevice(params) {
  return (dispatch) => {
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.ENABLE_TRUSTED_DEVICE,
      data: params,
    }).then((response) => {
      return { status: 200, data: response.data };
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function getTrustedDevices(params) {
  return (dispatch) => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_TRUSTED_DEVICES,
      params,
    }).then((response) => {
      return response.data;
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function deleteTrustedDevices(params) {
  return (dispatch) => {
    return axios({
      method: Constants.DELETE,
      url: config.BASE_URL + RestPath.GET_TRUSTED_DEVICES,
      data: params,
    }).then((response) => {
      return { status: 200, data: response.data };
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function checkCupisV2Code(data) {
  return (dispatch) => {
    const params = {
      clientId: data.clientId,
      code: data.code
    };
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.CHECK_CUPISV2_CODE,
      data: params,
    }).then((response) => {
      return { status: 200, data: response.data };
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}

export function getCupisFeedInfo(feedType) {
  return (dispatch) => {
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.CUPIS_FEED}?feedType=${feedType}`
    }).then((response) => {
      return response?.data?.data;
    }).catch((error) => {
      //console.log(error)
    });
  };
}

export function exportOneClickPdf(credentials) {
  return (dispatch) => {
    const data = {
      credentials
    };
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.EXPORT_ONE_CLICK_PDF,
      responseType: 'blob',
      data: data,
    }).then((response) => {
      const file = new Blob(
        [response.data],
        { type: 'application/pdf' });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      window.open(fileURL);
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  };
}


export function complaints(formData) {
  return dispatch => {
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.COMPLAINTS,
      data: formData,
      headers: {
        'Content-Type': "multipart/form-data"
      }
    }).then((response) => {
      NotificationService.success({ message: LanguageService.getTranslation('success', 'account') });
      return response;
    }).catch((error) => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    });
  }
}

export function getSelfAssessment() {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_SELF_ASSESSMENT,
    }).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err);
    })
  }
}

export function sendSelfAssessment(data) {
  return dispatch => {
    return axios({
      method: Constants.POST,
      url: config.BASE_URL + RestPath.SEND_SELF_ASSESSMENT,
      data
    }).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err);
    })
  }
}


export function getSelfAssessmentResult(id) {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: `${config.BASE_URL}${RestPath.GET_SELF_ASSESSMENT_RESULT}/${id}/PDF`,
      responseType: 'blob',
    }).then((response) => {
      const file = new Blob(
        [response.data],
        { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = 'self_assessment_result.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);
    }).catch(error => {
      if (error.response) {
        NotificationService.error({ message: ErrorHelper.getMessage(error) });
      }
    })
  }
}

// COMPLAINTS_HISTORY

export function getPlayerComplaintsFormHistory(pageId, takeCount) {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.COMPLAINTS_HISTORY,
      params: { pageId, takeCount }
    }).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err);
    })
  }
}

export function getPlayerComplaintDetails(complaintId) {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.COMPLAINT_DETAILS + '/' + complaintId,
    }).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err);
    })
  }
}

export function getPlayerTotalTransactions() {
  return dispatch => {
    return axios({
      method: Constants.GET,
      url: config.BASE_URL + RestPath.GET_PLAYER_TOTAL_TRANSACTIONS,
    }).then((response) => {
      return response.data
    }).catch(err => {
      console.log(err);
    })
  }
}